import { ChoiceQuestion } from "./choice-question";
import type { QuestionTypeRendererProps } from "./shared";

type DropdownQuestionProps = QuestionTypeRendererProps<"dropdown">;

export default function DropdownQuestionType(props: DropdownQuestionProps) {
  return <ChoiceQuestion {...props} kind="dropdown" />;
}
